<template>
  <div>
    <div class="clearfix">
      <nuxt-link
        class="button is-primary is-pulled-right"
        :to="localePath('office-reclamations-id-create-info')"
      >{{ $t("form.create") }}</nuxt-link>

      <h3 class="title is-3">{{ $t('form.infos') }}</h3>
    </div>
    <reclamation-info v-for="info in active.infos" :key="info.id" :info="info" />
  </div>
</template>
<script>
import ReclamationInfo from '@/components/Reclamation/Info';

export default {
  components: {
    ReclamationInfo
  },

  computed: {
    active() {
      return this.$store.state.reclamations.active;
    }
  },
}
</script>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/reclamations/_id/index.vue